// store.js
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import authtReducer from "../features/auth/authReducer";
import interviewReducer from "../features/interview/interviewSlicee"
import bCategoryReducer from "../features/bcategory/bcategorySlice";
import newsReducer from "../features/news/newsSlice";
import associationReducer from "../features/association/associationSlice";
import dmcReducer from "../features/dmc/dmcSlice";
import memberReducer from "../Association/features/member/memberSlice";
import updateReducer from "../Association/features/update/UpdateSlice";
import circularReducer from "../Association/features/circular/CircularSlice";
import hotelReducer from "../features/luxury/hotel/hotelSlice";
import transportReducer from "../features/luxury/transport/transportSlice";
import laxuryHotelReducer from "../Luxuryhotel/features/laxuryHotelSclice";
import chapterReducer from "../Association/features/chapters/chapterslice";
import boardReducer from "../Association/features/boards/boardSclice";
import advisoryBoardReducer from "../features/AdvisoryBoard/AdvisoryBoardSlice";
import AdvertisementReducer from "../features/Advertisement/AdvertisementSlice";
import GalleryImageSlice from "../features/GalleryImage/GalleryImageSlice";
import CountryReducer from "../TwoCampus/features/CountrySclice";
import CountryCatReducer from "../TwoCampus/features/CountryCatSclice";
import CountryDataReducer from "../TwoCampus/features/CountryDataSclice";
import pppReducer from "../features/ppp/pppSclice";
import NewsRepoterReducer from "../features/NewsRepoter/NewsRepoterSlice";
import InvestmentOpportunityReducer from "../ppp/features/InvestmentOpportunitySclice";
import TourismPolicyReducer from "../ppp/features/TourismPolicySclice";
import StakeholderReducer from "../ppp/features/StakeholderSlice";
import PhotographReducer from "../ppp/features/PhotographsSlice";
import EbroucherReducer from "../ppp/features/EbrouchersSlice";
import VideoReducer from "../ppp/features/VideoSlice";
import TvProgramReducer from "../features/TvProgram/TvProgramSlice";
import RadioProgramReducer from "../features/RadioProgram/RadioProgramSlice";
import packageReducer from "../features/package/packageSlice";
import asegoBookingReducer from "../features/AsegoBooking/AsegoBookingSlice";
import villaBookingReducer from "../features/VillaBooking/VillaBookingSlice";
import tailorMadeReducer from "../features/tailorMade/tailorMadeSlice";
export const store = configureStore({
  reducer: {
    autht: authtReducer,
    auth: authReducer,
    interview: interviewReducer,
    bCategory: bCategoryReducer,
    news: newsReducer,
    association: associationReducer,
    member: memberReducer,
    update: updateReducer,
    circular: circularReducer,
    hotel: hotelReducer,
    transport: transportReducer,
    laxuryHotelS: laxuryHotelReducer,
    board: boardReducer,
    chapter: chapterReducer,
    advisoryBoard: advisoryBoardReducer,
    advertisement: AdvertisementReducer,
    country: CountryReducer,
    countryCat: CountryCatReducer,
    countryData: CountryDataReducer,
    ppp: pppReducer,
    newsRepoter: NewsRepoterReducer,
    tourismPolicy: TourismPolicyReducer,
    investmentOpportunity: InvestmentOpportunityReducer,
    Stakeholder: StakeholderReducer,
    globalGallery: GalleryImageSlice,
    Ebroucher: EbroucherReducer,
    Photograph: PhotographReducer,
    Video: VideoReducer,
    tvprogram: TvProgramReducer,
    radioprogram: RadioProgramReducer,
    package: packageReducer,
    dmc: dmcReducer,
    tailorMade: tailorMadeReducer,
    asegoBooking: asegoBookingReducer,
    villaBooking: villaBookingReducer,
  },
});
